import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentService } from 'src/app/services/content.service';
import { DataLesson } from 'src/app/shared/interfaces/lesson.interface';
import { Subject, Subscription, map, takeUntil, tap } from 'rxjs';
import { differenceInDays } from 'src/app/shared/functions';
import { FechaEsPipe } from "../../shared/interfaces/fecha-es.pipe";
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-notifications',
    standalone: true,
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [CommonModule, FechaEsPipe, RouterModule]
})
export class NotificationsComponent {
  activitiesCloseToExpired: DataLesson[] = [];
  activitiesExpired: DataLesson[] = [];
  selectedActivity: DataLesson | undefined;
  notifications$: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(public contentService: ContentService){
    this.notifications$ = this.contentService.activitiesForNotifications$.pipe(takeUntil(this.destroy$)).subscribe({
      next: resp => {
        this.notifications(resp);
      }
    })
  }

  // ngOnInit(): void {
  //   this.notifications();
  // }

  notifications(activities: any[]): void {
    activities.forEach(activity => {
      if ([3, 1].includes(activity.daysLeft)) {
        this.activitiesCloseToExpired.push(activity);
      }
      if (activity.daysLeft < 0) {
        this.activitiesExpired.push(activity);
      }
    });
  }

  selectActivity(activity: any) {
    this.selectedActivity = activity;
  }

  private daysUntilDue(date: string | Date): number {
    const dueDate = new Date(date);
    const today = new Date();
    return Math.ceil((dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  }

}
